module.exports = __webpack_public_path__ + "img/banner-9-zh.fb1b97bf.png";